import { render, staticRenderFns } from "./ImportWhatsappContactsFromFile.vue?vue&type=template&id=0f30ede0"
import script from "./ImportWhatsappContactsFromFile.vue?vue&type=script&lang=js"
export * from "./ImportWhatsappContactsFromFile.vue?vue&type=script&lang=js"
import style0 from "./ImportWhatsappContactsFromFile.vue?vue&type=style&index=0&id=0f30ede0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports